export default "__VITE_ASSET__gnm_Jlcl__"